export default __webpack_public_path__ + "static/media/CSS.b6654865.png";